import script from "./Animation.vue?vue&type=script&setup=true&lang=js"
export * from "./Animation.vue?vue&type=script&setup=true&lang=js"

import "./Animation.vue?vue&type=style&index=0&id=2bd24371&lang=sass&scoped=true"

import exportComponent from "/Users/yablonev/Desktop/Yablonev/Coding/GitHub/TON/Highload-UI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd24371"]])

export default __exports__